import React, { Component } from 'react';
import Helmet from 'react-helmet';
import config from '../../data/SiteConfig';
import Header from '../components/Header';
import HomeView from '../components/Home';
import Footer from '../components/Footer/Footer';
import SEO from '../components/SEO/SEO';

class Index extends Component {
  render() {
    const equipos = this.props.data.allMarkdownRemark.edges.map(edge => edge.node.frontmatter);
    return (
      <div className="index-container">
        <Header />
        <SEO />
        <Helmet title={config.siteTitle} />
        <HomeView equipos={equipos} />
        <Footer config={config} />
      </div>
    );
  }
}

export default Index;

/* eslint no-undef: "off" */
export const pageQuery = graphql`
  query EquiposCalculadora {
    allMarkdownRemark(sort: { order: ASC, fields: [frontmatter___potencia] }) {
      edges {
        node {
          frontmatter {
            nombre
            potencia
            grupo
            precaucion
            cover {
              childImageSharp {
                responsiveSizes(maxWidth: 400) {
                  src
                  srcSet
                  sizes
                }
              }
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.jsx